// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__Yc8kp","container__text":"Checkbox_container__text__8q53G","checkmark":"Checkbox_checkmark__GCcQ9"};